import React from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import './DateHeader.scss';

const DateHeader = ({
  daysArray,
  position,
  isCurrentMonthAndYear,
  currentDate,
  gridContainerRef,
}) => {
  const headerClassName =
    position === 'left'
      ? 'habit-date-header-left'
      : position === 'right'
      ? 'habit-date-header-right'
      : position === 'center'
      ? 'habit-date-header-center'
      : 'habit-date-header';

  return (
    <div ref={gridContainerRef} className={headerClassName}>
      {daysArray.map(day => (
        <div
          key={day}
          className={`day-column ${
            isCurrentMonthAndYear && day === currentDate.getDate() ? 'isCurrentDay' : ''
          }`}
        >
          {day}
          {isCurrentMonthAndYear && day === currentDate.getDate() && (
            <div className="circle-background">
              <FontAwesome name="circle" style={{ fontSize: '25px', color: '#515554' }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

DateHeader.propTypes = {
  daysArray: propTypes.array,
  position: propTypes.string,
  isCurrentMonthAndYear: propTypes.bool,
  currentDate: propTypes.instanceOf(Date),
  gridContainerRef: propTypes.object,
};

export default DateHeader;
